<template>
  <Card class="pricing-plan-card">
    <Row type="flex" justify="center" class="plan-card-header">
      <h2>{{ plan.title }}</h2>
    </Row>
    <Row type="flex" justify="center" align="middle">
      <i style="text-align: center;">{{ plan.description }}</i>
    </Row>
    <Row type="flex" justify="center" align="middle">
      <h1 class="price">{{ showAnnual ? plan.annualPrice : plan.monthlyPrice }} <span style="font-size: 16px" class="light-grey-text">/month</span></h1>
    </Row>
    <Row type="flex" justify="center" align="middle">
      <h4 class="increment light-grey-text">
        <a @click="$emit('show-annual-toggle');" class="light-grey-text">
          {{ showAnnual ? 'Paid Annually' : 'Paid Monthly' }} <Icon type="loop"></Icon>
        </a>
      </h4>
    </Row>
    <Row type="flex" justify="start" align="middle" style="padding-bottom: 16px;">
      <Col span="24" style="padding: 0 16px;">
        <Row v-for="(feature, $index) in plan.features" :key="$index" type="flex" justify="start">
          <span><Icon :class="feature.enabled ? 'green' : 'grey-icon'" :type="feature.enabled ? 'checkmark-round' : 'close-round'"></Icon> {{ feature.quantity }} {{ feature.title }} 
            <Poptip
              placement="bottom"
              v-if="faqs[$index]"
              :title="faqs[$index].question"
              :content="faqs[$index].answers[0]">
                <a class="light-grey-text"><h5><Icon type="information-circled"></Icon></h5></a>
            </Poptip>
            </span>
        </Row>
      </Col>
    </Row>
    <Row type="flex" justify="center" align="middle">
      <a :href="buildUrl(plan)" class="nav-item">
        <Button
          type="primary"
          class="green-btn"
          :href="buildUrl(plan)"><strong>Start Free Trial</strong>  <Icon type="arrow-right-c"></Icon>
        </Button>
      </a>
    </Row>
  </Card>
</template>
<script>
import pricingFAQs from '../services/faqs';

export default {
  data() { return { faqs: pricingFAQs }; },
  props: {
    showAnnual: Boolean,
    buttonType: String,
    plan: {
      title: String,
      description: String,
      annualPrice: String,
      monthlyPrice: String,
      featureList: Array,
    },
  },
  methods: {
    buildUrl(plan) {
      const vm = this;
      return `${process.env.SUBSCRIPTION_URL}?tier=${plan.tier}&interval=${vm.showAnnual ? 'year' : 'month'}`;
    },
  },
};
</script>
<style lang="css">
.light-grey-text {
  color: rgba(110, 108, 108, 0.6);
}

a.light-grey-text:hover {
  color: rgba(110, 108, 108, 0.8);
}

a.light-grey-text:active {
  color: rgba(110, 108, 108, 0.9);
}

.pricing-plan-card {
  margin: 8px;
  max-width: 245px;
}

.plan-card-header {
  padding-bottom: 16px;
  padding-top: 6px;
}

.price {
  font-weight: bold;
  padding-top: 16px;
}

.increment {
  padding-bottom: 16px;
}
  
/* to put in theme? it's in the UI too... */
.ivu-card {
  margin: 8px;
}

.ivu-card-bordered {
  border: none;
}

.feature-item {
  font-size: 14px;
}

.grey-icon {
  color: rgba(107, 124, 147, 0.5);
}

</style>


// WEBPACK FOOTER //
// src/components/PricingPlanCard.vue